import { mapActions, mapGetters } from 'vuex';
import { buildAgentBalances } from 'shared_js/utils/buildAgentBalance';
import buildBuka20Url from 'shared_js/helpers/urlHelper/buildBuka20Url';
import mitraPaymentDomainBaseUrl from 'shared_js/helpers/urlHelper/mitraPaymentDomainBaseUrl';
import paymentVjiHost from 'shared_js/helpers/urlHelper/paymentVjiHost';
import {
  PAYMENT_METHOD_TYPE_WALLET,
  PAYMENT_METHOD_TYPE_VJI_WALLET,
} from 'shared_js/utils/buka20-constants';

/** Saldo / BukaPay top-up redirect; use on pages or in PaymentMethodBox. */
export const saldoTopupMixin = {
  computed: {
    ...mapGetters(['b2b2cAccessToken']),
  },
  methods: {
    async openTopupSaldoPage(paymentMethodType) {
      const targetType =
        paymentMethodType ||
        this.paymentMethodType ||
        this.internalPaymentMethodType;
      const isVjiWalletPaymentMethod =
        targetType === PAYMENT_METHOD_TYPE_VJI_WALLET;
      const topupHost = isVjiWalletPaymentMethod
        ? paymentVjiHost
        : mitraPaymentDomainBaseUrl;
      const topupPath = isVjiWalletPaymentMethod
        ? `/topup/wallet?token=${this.b2b2cAccessToken}`
        : '/topup';
      const topupUrl = await buildBuka20Url(`${topupHost}${topupPath}`);

      if (isVjiWalletPaymentMethod) {
        window.location.href = topupUrl;
      } else {
        window.location.replace(topupUrl);
      }
    },
  },
};

/**
 * Payment method selection for item-mitra checkout (Saldo Mitra, BukaPay).
 * Pair with PaymentMethodBox: :balanceList="balanceList", @handleError="handleBalanceError".
 */
export default {
  mixins: [saldoTopupMixin],
  data() {
    return {
      currentBalance: [],
      paymentMethodType: PAYMENT_METHOD_TYPE_WALLET,
      balanceSufficient: true,
    };
  },
  computed: {
    ...mapGetters(['isWalletVjiEnabled']),
    balanceList() {
      return [...this.currentBalance].sort((a, b) => {
        if (a.type === PAYMENT_METHOD_TYPE_VJI_WALLET) return -1;
        if (b.type === PAYMENT_METHOD_TYPE_VJI_WALLET) return 1;
        if (a.name < b.name) return 1;
        if (a.name > b.name) return -1;
        return 0;
      });
    },
    selectedPaymentBalance() {
      const entry = this.currentBalance.find(
        balance => balance.type === this.paymentMethodType,
      );
      return entry?.balance ?? 0;
    },
  },
  methods: {
    ...mapActions('mitraItems', ['retrieveUserAgentProfile']),
    async initializeCheckoutPayment() {
      await this.$store.dispatch('initWalletVji');
      await this.fetchAgentBalances();
    },
    async fetchAgentBalances() {
      const mitraBalance = await this.retrieveUserAgentProfile();
      this.$store.commit(
        'setWalletVjiBound',
        mitraBalance?.wallet_vji?.bind_status === true,
      );
      this.currentBalance = buildAgentBalances(
        mitraBalance,
        this.isWalletVjiEnabled,
      );
    },
    handleBalanceError(isSufficient) {
      this.balanceSufficient = isSufficient;
    },
    goToBukapayActivationPage() {
      window.location.href = `${process.env.MITRA_BUKALAPAK_BASE_URL}/profile`;
    },
  },
};
